import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ToastContainer } from "react-toastify";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals.js";
import { store, persistor } from "./redux/Store";

const root = ReactDOM.createRoot(document.getElementById("root"));

navigator.serviceWorker
  .register("/firebase-messaging-sw.js")
  .then((registration) => {
    console.log("Service Worker registered:", registration);
  })
  .catch((error) => {
    console.error("Service Worker registration failed:", error);
  });

root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <BrowserRouter>
        <App />
        <ToastContainer autoClose={2000} />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

reportWebVitals();